// Change array element index
export function arrayMove (array: any[], fromIndex: number, toIndex: number): any[] {
  const element = array[fromIndex]
  array.splice(fromIndex, 1)
  array.splice(toIndex, 0, element)
  return array
}

export function countCommonKeys (array1: any[], array2: any[]): number {
  let count = 0

  for (const key of array1) {
    if (array2.includes(key)) {
      count++
    }
  }

  return count
}

// Helper function to recursively calculate total length
export function getNestedArrayLength (array: any[]): number {
  let totalLength = 0

  function calculateLength (array: any[]): void {
    for (let i = 0; i < array.length; i++) {
      const element = array[i]
      if (Array.isArray(element)) {
        // if element is an array, recursively calculate its length
        calculateLength(element)
      } else {
        // if element is not an array, add 1 to total length
        totalLength++
      }
    }
  }

  calculateLength(array)

  return totalLength
}
